import { render, staticRenderFns } from "./FinalInsuredSignBoard.vue?vue&type=template&id=7d65adec&scoped=true"
import script from "./FinalInsuredSignBoard.vue?vue&type=script&lang=js"
export * from "./FinalInsuredSignBoard.vue?vue&type=script&lang=js"
import style0 from "./FinalInsuredSignBoard.vue?vue&type=style&index=0&id=7d65adec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d65adec",
  null
  
)

/* custom blocks */
import block0 from "./FinalInsuredSignBoard.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports